import { render, staticRenderFns } from "./AppTemplate.vue?vue&type=template&id=7d68a6de&"
import script from "./AppTemplate.vue?vue&type=script&lang=js&"
export * from "./AppTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VMain,VSheet})
